import React from 'react';
import axios from 'axios'
import SwipeableViews from 'react-swipeable-views';

class MainAppContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      guestID: "",
      guestPhoneNumber: "",
      invitationTo: "",
      wtpsMsg: "",
      isVideoMuted: true,
      nbrOfInvited: "",
      didstart: false,
      countdown: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      listOfInv: [],

      AppData: {
        husband: "",
        bride: "",
        bibleQuotes: "",
        evangelist: "",
        marriageQuotes: [],
        ceremonyTitle: "",
        ceremonyDate: "",
        ceremonyDateAR: "",
        ceremonyDateAR2: "",
        ceremonyTime: "",
        ceremonyCurch: "",
        ceremonyCurchAR: "",
        ceremonyLocation: "",
        ceremonyGoogleMap: "",
        dinner: {
          dinnerTitle: "",
          dinnerDate: "",
          dinnerTime: "",
          dinnerResto: "",
          dinnerLocation: "",
          dinnerGoogleMap: ""
        },
        gift: {
          giftRegistryTitle: "",
          giftRegistry: "",
          giftRegistryID: ""
        },
        rsvp: {
          rsvpTitle: "",
          rsvpReplyDate: "",
          rsvpNumberOfPersons: "",
          nbrOfInvited: ""
        }
      },
      apiCall: "https://wed.techynnovative.com/WedInviteBackEnd//v1/api/get_data",
      suffix : "Coco", // Dynamic table name,
      displayLastPage: false,
      currentSlideIndex: 0
    };
  }


  componentDidMount = async () => {
    // Start countdown timer
    this.startCountdown();
    
    let AppData

    await fetch("AppData.json").then(
      function (res) {
        return res.json()
      }).then(function (data) {
        AppData = data.data
      }).catch(
        function (err) {
          console.log(err, ' error')
        }
      )

    let tempData
    let guestID = window.location.search
    // let guestID = "?id=ghjy29xnla9d8aa"

    await axios({
      method: "get",
      url:`${this.state.apiCall}/search${guestID}&Suffix=${this.state.suffix}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(response => {
        tempData = response.data
      })
      .catch(error => {
        if (axios.isCancel(error)) { console.log(error.message); }
      });

    const listOfInv = tempData.ListOfInv ? JSON.parse(tempData.ListOfInv) : [];
    this.setState({
      AppData,
      guestID: tempData.id ? tempData.id : '',
      invitationTo: tempData.name ? tempData.name : '',
      nbrOfInvited: tempData.NumberOfGuests ? tempData.NumberOfGuests : '',
      guestPhoneNumber: tempData.mobilenumber ? tempData.mobilenumber : '',
      wtpsMsg: tempData.wtpsMsg ? tempData.wtpsMsg : '',
      listOfInv
    })
  }

  startCountdown = () => {
    // Wedding date: September 4th, 2025 at 7:00 PM Lebanon time (UTC+3)
    const weddingDate = new Date('2025-09-04T18:00:00+03:00').getTime();

    const timer = setInterval(() => {
      // Get current time in Lebanon
      const now = new Date().toLocaleString('en-US', { timeZone: 'Asia/Beirut' });
      const currentTime = new Date(now).getTime();
      
      const distance = weddingDate - currentTime;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0) {
        clearInterval(timer);
        this.setState({
          countdown: {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0
          }
        });
      } else {
        this.setState({
          countdown: {
            days,
            hours,
            minutes,
            seconds
          }
        });
      }
    }, 1000);

    // Clear interval when component unmounts
    return () => clearInterval(timer);
  };

  handleRsvpStatusChange = (index, status) => {
    this.setState(prevState => ({
      listOfInv: prevState.listOfInv.map((person, i) => {
        if (i === index) {
          return {
            ...person,
            status: person.status === status ? 'P' : status,
          };
        }
        return person;
      }),
    }));
  };

  startCardTour = () => {
    document.getElementById("SwipeableViews").style.visibility = "visible"
    document.getElementById("startPage").style.visibility = "hidden"

    this.setState({ didstart: true, isVideoMuted: false })
  }

  handleMute = () => {
    this.setState({ isVideoMuted: !this.state.isVideoMuted })
  }

  handleSlideChange = (index) => {
    this.setState({ currentSlideIndex: index });
  }

  reserve = async () => {
    const numberOfAttendees = this.state.listOfInv.filter(p => p.status === 'A').length;

    let params = {
      id: this.state.guestID,
      Suffix: this.state.suffix,
      Attending: numberOfAttendees > 0 ? "yes" : "no",
      NumberOfAttendes: numberOfAttendees,
      ListOfInv: JSON.stringify(this.state.listOfInv)
    }
    await axios({
      method: "patch",
      url: `${this.state.apiCall}/RSV`,
      data: params,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(response => {
        if (response)
          this.setState({ displayLastPage: true })
      })
      .catch(error => {
        if (axios.isCancel(error)) { console.log(error.message); }
      });

  }

  render() {
    let { AppData, isVideoMuted } = this.state
    return (
      <>
        <div id="swipeableViewsParentContainer" style={this.state.displayLastPage === true ? { display: "none" } : { display: "block" }}>
          <div id="leafContainer" data-image="bigLeaf" className="bigLeaf">
            <div style={{ top: "115%", left: "4271px", animationName: "fade, drop", aniationDuration: "21.5328s, 21.5328s", animationDelay: "0.649181s, 0.649181s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "clockwiseSpin", animationDuration: "17.2989s" }} />
            </div>
            <div style={{ top: "115%", left: "3209px", animationName: "fade, drop", animationDuration: "20.5643s, 20.5643s", animationDelay: "0.0979504s, 0.0979504s" }}>
              <img alt="realLeaf" src="img/realLeaf4.png" style={{ animationName: "clockwiseSpin", animationDuration: "14.8381s" }} />
            </div>
            <div style={{ top: "115%", left: "1033px", animationName: "fade, drop", animationDuration: "32.6238s, 32.6238s", animationDelay: "0.761477s, 0.761477s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "counterclockwiseSpinAndFlip", animationDuration: "11.7593s" }} />
            </div>
            <div style={{ top: "115%", left: "4494px", animationName: "fade, drop", animationDuration: "24.3477s, 24.3477s", animationDelay: "0.44706s, 0.44706s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "clockwiseSpin", animationDuration: "17.0681s" }} />
            </div>
            <div style={{ top: "115%", left: "2248px", animationName: "fade, drop", animationDuration: "26.1889s, 26.1889s", animationDelay: "0.078033s, 0.078033s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "clockwiseSpin", animationDuration: "11.4703s" }} />
            </div>
            <div style={{ top: "115%", left: "3547px", animationName: "fade, drop", animationDuration: "31.2799s, 31.2799s", animationDelay: "0.423443s, 0.423443s" }}>
              <img alt="realLeaf" src="img/realLeaf4.png" style={{ animationName: "counterclockwiseSpinAndFlip", animationDuration: "12.0255s" }} />
            </div>
            <div style={{ top: "115%", left: "205px", animationName: "fade, drop", animationDuration: "30.8377s, 30.8377s", animationDelay: "0.623964s, 0.623964s" }}>
              <img alt="realLeaf" src="img/realLeaf3.png" style={{ animationName: "clockwiseSpin", animationDuration: "13.0019s" }} />
            </div>
            <div style={{ top: "115%", left: "3209px", animationName: "fade, drop", animationDuration: "20.5643s, 20.5643s", animationDelay: "0.0979504s, 0.0979504s" }}>
              <img alt="realLeaf" src="img/realLeaf4.png" style={{ animationName: "clockwiseSpin", animationDuration: "14.8381s" }} />
            </div>
            <div style={{ top: "115%", left: "1033px", animationName: "fade, drop", animationDuration: "32.6238s, 32.6238s", animationDelay: "0.761477s, 0.761477s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "counterclockwiseSpinAndFlip", animationDuration: "11.7593s" }} />
            </div>
            <div style={{ top: "115%", left: "4494px", animationName: "fade, drop", animationDuration: "24.3477s, 24.3477s", animationDelay: "0.44706s, 0.44706s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "clockwiseSpin", animationDuration: "17.0681s" }} />
            </div>
            <div style={{ top: "115%", left: "43px", animationName: "fade, drop", animationDuration: "35.0827s, 35.0827s", animationDelay: "0.36684s, 0.36684s" }}>
              <img alt="realLeaf" src="img/realLeaf3.png" style={{ animationName: "clockwiseSpin", animationDuration: "15.6451s" }} />
            </div>
            <div style={{ top: "115%", left: "3209px", animationName: "fade, drop", animationDuration: "20.5643s, 20.5643s", animationDelay: "0.0979504s, 0.0979504s" }}>
              <img alt="realLeaf" src="img/realLeaf4.png" style={{ animationName: "clockwiseSpin", animationDuration: "14.8381s" }} />
            </div>
            <div style={{ top: "115%", left: "1033px", animationName: "fade, drop", animationDuration: "32.6238s, 32.6238s", animationDelay: "0.761477s, 0.761477s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "counterclockwiseSpinAndFlip", animationDuration: "11.7593s" }} />
            </div>
            <div style={{ top: "115%", left: "4494px", animationName: "fade, drop", animationDuration: "24.3477s, 24.3477s", animationDelay: "0.44706s, 0.44706s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "clockwiseSpin", animationDuration: "17.0681s" }} />
            </div>
            <div style={{ top: "115%", left: "2826px", animationName: "fade, drop", animationDuration: "35.7176s, 35.7176s", animationDelay: "0.142368s, 0.142368s" }}>
              <img alt="realLeaf" src="img/realLeaf1.png" style={{ animationName: "clockwiseSpin", animationDuration: "17.8249s" }} />
            </div>
            <div style={{ top: "115%", left: "621px", animationName: "fade, drop", animationDuration: "37.7397s, 37.7397s", animationDelay: "0.396265s, 0.396265s" }}>
              <img alt="realLeaf" src="img/realLeaf3.png" style={{ animationName: "clockwiseSpin", animationDuration: "11.9869s" }} />
            </div>
            <div style={{ top: "115%", left: "295px", animationName: "fade, drop", animationDuration: "23.2892s, 23.2892s", animationDelay: "0.244458s, 0.244458s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "clockwiseSpin", animationDuration: "18.1451s" }} />
            </div>
            <div style={{ top: "115%", left: "3295px", animationName: "fade, drop", animationDuration: "21.5757s, 21.5757s", animationDelay: "0.833078s, 0.833078s" }}>
              <img alt="realLeaf" src="img/realLeaf1.png" style={{ animationName: "clockwiseSpin", animationDuration: "15.8504s" }} />
            </div>
            <div style={{ top: "115%", left: "4014px", animationName: "fade, drop", animationDuration: "34.9891s, 34.9891s", animationDelay: "0.333657s, 0.333657s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "clockwiseSpin", animationDuration: "16.1805s" }} />
            </div>
            <div style={{ top: "115%", left: "84px", animationName: "fade, drop", animationDuration: "29.3781s, 29.3781s", animationDelay: "0.30615s, 0.30615s" }}>
              <img alt="realLeaf" src="img/realLeaf1.png" style={{ animationName: "clockwiseSpin", animationDuration: "11.7186s" }} />
            </div>
            <div style={{ top: "115%", left: "3209px", animationName: "fade, drop", animationDuration: "20.5643s, 20.5643s", animationDelay: "0.0979504s, 0.0979504s" }}>
              <img alt="realLeaf" src="img/realLeaf4.png" style={{ animationName: "clockwiseSpin", animationDuration: "14.8381s" }} />
            </div>
            <div style={{ top: "115%", left: "1033px", animationName: "fade, drop", animationDuration: "32.6238s, 32.6238s", animationDelay: "0.761477s, 0.761477s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "counterclockwiseSpinAndFlip", animationDuration: "11.7593s" }} />
            </div>
            <div style={{ top: "115%", left: "4494px", animationName: "fade, drop", animationDuration: "24.3477s, 24.3477s", animationDelay: "0.44706s, 0.44706s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "clockwiseSpin", animationDuration: "17.0681s" }} />
            </div>
            <div style={{ top: "115%", left: "863px", animationName: "fade, drop", animationDuration: "23.7322s, 23.7322s", animationDelay: "0.76869s, 0.76869s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "counterclockwiseSpinAndFlip", animationDuration: "14.3942s" }} />
            </div>
            <div style={{ top: "115%", left: "2771px", animationName: "fade, drop", animationDuration: "21.7417s, 21.7417s", animationDelay: "0.0370709s, 0.0370709s" }}>
              <img alt="realLeaf" src="img/realLeaf4.png" style={{ animationName: "counterclockwiseSpinAndFlip", animationDuration: "15.8919s" }} />
            </div>
            <div style={{ top: "115%", left: "935px", animationName: "fade, drop", animationDuration: "38.3105s, 38.3105s", animationDelay: "0.920299s, 0.920299s" }}>
              <img alt="realLeaf" src="img/realLeaf1.png" style={{ animationName: "clockwiseSpin", animationDuration: "19.0806s" }} />
            </div>
            <div style={{ top: "115%", left: "3347px", animationName: "fade, drop", animationDuration: "37.37s, 37.37s", animationDelay: "0.0346564s, 0.0346564s" }}>
              <img alt="realLeaf" src="img/realLeaf3.png" style={{ animationName: "clockwiseSpin", animationDuration: "17.9137s" }} />
            </div>
            <div style={{ top: "115%", left: "3209px", animationName: "fade, drop", animationDuration: "20.5643s, 20.5643s", animationDelay: "0.0979504s, 0.0979504s" }}>
              <img alt="realLeaf" src="img/realLeaf4.png" style={{ animationName: "clockwiseSpin", animationDuration: "14.8381s" }} />
            </div>
            <div style={{ top: "115%", left: "1033px", animationName: "fade, drop", animationDuration: "32.6238s, 32.6238s", animationDelay: "0.761477s, 0.761477s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "counterclockwiseSpinAndFlip", animationDuration: "11.7593s" }} />
            </div>
            <div style={{ top: "115%", left: "4494px", animationName: "fade, drop", animationDuration: "24.3477s, 24.3477s", animationDelay: "0.44706s, 0.44706s" }}>
              <img alt="realLeaf" src="img/realLeaf2.png" style={{ animationName: "clockwiseSpin", animationDuration: "17.0681s" }} />
            </div>
            <div style={{ top: "115%", left: "1883px", animationName: "fade, drop", animationDuration: "22.9141s, 22.9141s", animationDelay: "0.144015s, 0.144015s" }}>
              <img alt="realLeaf" src="img/realLeaf4.png" style={{ animationName: "clockwiseSpin", animationDuration: "11.7241s" }} />
            </div>
            <div style={{ top: "115%", left: "1440px", animationName: "fade, drop", animationDuration: "30.387s, 30.387s", animationDelay: "0.112946s, 0.112946s" }}>
              <img alt="realLeaf" src="img/realLeaf1.png" style={{ animationName: "clockwiseSpin", animationDuration: "12.6348s" }} />
            </div>
          </div>

          {this.state.didstart &&
            <video autoPlay={true} muted={isVideoMuted} playsInline={true} loop={true} controls={false} id="preweddingvideo" >
              <source src="/video/Chris.mp4" type="video/mp4" />
            </video>
          }

          <div id="startPage" className='swipeablePage' >
            <div style={{ fontFamily: "'Caveat', cursive", fontSize: "36px", marginTop: "10%", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>Welcome</div>
            <div style={{ fontFamily: "'Caveat', cursive", fontSize: "32px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>{this.state.invitationTo}</div>

            <div id="startPageBtn" onClick={this.startCardTour} >
              <div style={{ fontFamily: "'Ubuntu', sans-serif, Verdana", fontSize: "30px", marginTop: "35px" }}>Tap</div>
              <div style={{ fontFamily: "'Ubuntu', sans-serif, Verdana", fontSize: "30px" }}>to</div>
              <div style={{ fontFamily: "'Ubuntu', sans-serif, Verdana", fontSize: "30px" }}>Start</div>
            </div>
          </div>

          <SwipeableViews 
            enableMouseEvents 
            id="SwipeableViews"
            onChangeIndex={this.handleSlideChange}
          >
            <div id="slide1" className='swipeablePage'>
              <div id="slide1Header">
                <div style={{ paddingTop: "25px", position: "relative" }}>
                  <div style={{ fontFamily: "'Caveat', cursive", fontSize: "36px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", textAlign: "left", paddingLeft: "50px" }}>Georges</div>
                  <div style={{ fontFamily: "'Caveat', cursive", fontSize: "36px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", textAlign: "center" }}>&</div>
                  <div style={{ fontFamily: "'Caveat', cursive", fontSize: "36px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", textAlign: "right", paddingRight: "50px" }}>Carole</div>
                </div>
                <div>‎ </div>  
                <div>‎ </div>  
                <div>‎ </div>  
                <div>‎ </div>  
                <div style={{ fontFamily: "'Caveat', cursive", fontSize: "32px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>Are Getting Married</div>  
                <div>‎ </div>  
                <div style={{ fontFamily: "'Caveat', cursive", fontSize: "32px", marginTop: "20px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>
                  <div>Only</div>
                  <div style={{ display: "flex", justifyContent: "center", gap: "30px", marginTop: "25px" }}>
                    <div style={{ textAlign: "center" }}>
                      <div style={{ fontSize: "40px", fontFamily: "'Caveat', cursive", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>{this.state.countdown.days}</div>
                      <div style={{ fontSize: "24px", fontFamily: "'Caveat', cursive", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>Days</div>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <div style={{ fontSize: "40px", fontFamily: "'Caveat', cursive", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>{this.state.countdown.hours}</div>
                      <div style={{ fontSize: "24px", fontFamily: "'Caveat', cursive", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>Hours</div>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <div style={{ fontSize: "40px", fontFamily: "'Caveat', cursive", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>{this.state.countdown.minutes}</div>
                      <div style={{ fontSize: "24px", fontFamily: "'Caveat', cursive", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>Minutes</div>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <div style={{ fontSize: "40px", fontFamily: "'Caveat', cursive", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>{this.state.countdown.seconds}</div>
                      <div style={{ fontSize: "24px", fontFamily: "'Caveat', cursive", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>Seconds</div>
                    </div>
                  </div>
                  <div style={{ marginTop: "25px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>left until our Big Day</div>
                </div>
              </div>
              <div id="slide1Body">
                {/* <div>{AppData.husband}</div>
                <div>&</div>
                <div>{AppData.bride}</div> */}
                {/* <div style={{ fontFamily: "'Lora', serif", fontSize: "20px" }}>Are Getting Married</div> */}
              </div>
            </div>

            <div id="slide2" className='swipeablePage' >
              <div id="slide2Header">
              </div>
              <div id="slide2Body">
                <div style={{ fontFamily: "'Caveat', cursive", fontSize: "24px", padding: "0 10px", marginTop: "-20px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>{AppData.bibleQuotes}</div>
                <div style={{ fontFamily: "'Caveat', cursive", fontSize: "16px", margin: "5px 0", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>{AppData.evangelist}</div>
                <div style={{ fontFamily: "'Caveat', cursive", fontSize: "20px", margin: "30px 0", padding: "0 20px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>
                  {AppData.marriageQuotes.map((eachElem, key) => {
                    if (eachElem === "")
                      return <br />
                    else
                      return <div key={key}>{eachElem}</div>
                  })}
                </div>
                <div className="great-vibes" style={{ marginTop: "-20px", fontSize: "32px" }} >جورج</div>
<div className="great-vibes" style={{ paddingTop: "10px", fontSize: "32px" }}>&</div>
<div className="great-vibes" style={{ paddingTop: "10px", fontSize: "32px" }}>كارول</div>
 

                 <div style={{ fontFamily: "'Caveat', cursive", fontSize: "20px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>وذلك نهار الخميس الواقع في {AppData.ceremonyDateAR2}</div> 
        
                <div style={{ fontFamily: "'Caveat', cursive", fontSize: "18px", padding: "0 10px", paddingTop: "10px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>On Thursday the 4th of September, 2025</div>
                {/* <div style={{ fontFamily: "'Great Vibes', cursive", fontSize: "38px", margin: "20px 0", }} >{AppData.husband}&nbsp;&nbsp;&&nbsp;&nbsp;{AppData.bride}</div> */}
                {/* <div style={{ fontFamily: "'Lora', serif", fontSize: "20px" }}> {AppData.ceremonyDate}</div> */}
 
              </div>

            </div>

            <div id="slide3" className='swipeablePage'>
              <div id="slide3Header">
                <div style={{ paddingTop: "15px", paddingLeft: "20px", textAlign: "left", fontFamily: "'Arial', sans-serif", fontSize: "32px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>Ceremony</div>
              </div>
              <div id="slide3Body">
                <div style={{ display: "flex", alignItems: "center", marginTop: "15px", padding: "0 20px" }}>
                  <a href={AppData.ceremonyGoogleMap} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                    <div style={{ fontSize: "22px", marginRight: "10px", color: "#ffffff", cursor: "pointer" }}>📍</div>
                  </a>
                  <div style={{ flex: 1, textAlign: "right" }}>
                    <div style={{ fontFamily: "'Arial', sans-serif", fontSize: "24px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>{AppData.ceremonyCurch}</div>
                    <div style={{ fontFamily: "'Arial', sans-serif", fontSize: "20px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>{AppData.ceremonyTime}</div>
                  </div>
                  <div style={{ fontSize: "22px", marginLeft: "10px", color: "#ffffff" }}>⛪</div>
                </div>

                <div style={{ paddingLeft: "20px", textAlign: "left", fontFamily: "'Arial', sans-serif", fontSize: "32px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", marginTop: "25px" }}>Dinner</div>

                <div style={{ display: "flex", alignItems: "center", marginTop: "15px", padding: "0 20px" }}>
                  <a href={AppData.dinner.dinnerGoogleMap} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                    <div style={{ fontSize: "22px", marginRight: "10px", color: "#ffffff", cursor: "pointer" }}>📍</div>
                  </a>
                  <div style={{ flex: 1, textAlign: "right" }}>
                    <div style={{ fontFamily: "'Arial', sans-serif", fontSize: "24px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>{AppData.dinner.dinnerResto}</div>
                    <div style={{ fontFamily: "'Arial', sans-serif", fontSize: "20px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400" }}>{AppData.dinner.dinnerTime}</div>
                  </div>
                  <div style={{ fontSize: "22px", marginLeft: "10px", color: "#ffffff" }}>🥂</div>
                </div>
              </div>

            </div>

            {AppData.gift && AppData.gift.giftRegistryTitle &&
              <div id="slide4" className='swipeablePage'>
                <div id="slide4Header">
                  <div style={{ paddingTop: "340px", fontFamily: "'Arial', sans-serif", fontSize: "32px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", textAlign: "center" }}>Gift Registry</div>
                </div>
                <div id="slide4Body">
                <div style={{ paddingTop: "20px" }}>‎</div>
                <div style={{ paddingTop: "20px" }}>‎</div>
                <div style={{ paddingTop: "20px" }}>‎</div>
                <div style={{ paddingTop: "20px" }}>‎</div>
                <div style={{ paddingTop: "20px" }}>‎</div>
                  <div style={{ fontFamily: "'Arial', sans-serif", fontSize: "22px", padding: "150px 15px 3px 15px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", textAlign: "center" }}> لائحة الهدايا لمن يرغب متوفّرة لدى</div>

                  <div style={{ fontFamily: "'Arial', sans-serif", fontSize: "22px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", textAlign: "center"}}>Whish (All Branches)  </div>
                  <div style={{ backgroundImage: "url(/img/image01.png)", backgroundSize: "contain", backgroundRepeat: "no-repeat", height: "35px", width: "100px", marginLeft: "calc(50% - 50px)" }} />
                  <div style={{ fontFamily: "'Arial', sans-serif", fontSize: "20px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", textAlign: "center" }}>Account ID: {AppData.gift.giftRegistryID}</div>
                </div>

              </div>
            }

            {AppData.rsvp && AppData.rsvp.rsvpTitle &&
              <div id="slide5" className='swipeablePage'>
                <div id="slide5Header">
                  <div style={{ paddingTop: "20px", fontFamily: "'Arial', sans-serif", fontSize: "36px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", textAlign: "center" }}>A Day to remember</div>
                  <div style={{ fontFamily: "'Arial', sans-serif", fontSize: "36px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", textAlign: "center" }}>With YOU</div>
                </div>
                <div id="slide5Body">
                  <div style={{ fontFamily: "'Arial', sans-serif", fontSize: "20px", padding: "40px 15px 10px 15px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", textAlign: "center" }}>For reservation – by 15 August</div>
                  <div style={{ fontFamily: "'Arial', sans-serif", fontSize: "20px", padding: "10px 15px 20px 15px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", textAlign: "center" }}>نرجو تأكيد الحضور قبل ١٥ آب</div>

                  <div className="guest-list-container">
                    {this.state.listOfInv.map((person, index) => (
                      <div key={index} className="guest-row">
                        <span className="guest-name">{person.name}</span>
                        <div className="rsvp-buttons">
                          <button
                            className={`rsvp-button accept ${person.status === 'A' ? 'selected' : ''}`}
                            onClick={() => this.handleRsvpStatusChange(index, 'A')}
                          >
                            Accept
                          </button>
                          <button
                            className={`rsvp-button decline ${person.status === 'D' ? 'selected' : ''}`}
                            onClick={() => this.handleRsvpStatusChange(index, 'D')}
                          >
                            Decline
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>

                  <button className='attendingPart' style={{ marginTop: "20px" }} onClick={this.reserve} >RSVP</button>
                </div>

              </div>
            }
            {/* {AppData.thanksQuote &&
              <div id="slide7" className='swipeablePage'>
                <div id="slide7Header">
                </div>
                <div id="slide7Body">
                  <div style={{ fontFamily: "'Lora', serif", fontSize: "21px", padding: "60px 15px 30px 15px" }}>{AppData.thanksQuote}</div>
                </div>
                <div id="slide7Footer">
                  <div id="muteUnmute" onClick={this.handleMute}>
                    {
                      isVideoMuted ?
                        <>&#128263;</>
                        :
                        <>&#128263;</>
                    }
                  </div>
                  <div style={{ fontFamily: "'Lora', serif", fontSize: "11px" }}></div>
                </div>
              </div>
            } */}
          </SwipeableViews>

          {this.state.didstart && !this.state.displayLastPage && this.state.currentSlideIndex !== 4 && (
            <div className="swipe-indicator">
              <div className="arrow">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div style={{ fontFamily: "'Lora', serif", fontSize: "11px", color: "#ffffff", marginTop: "10px" }}>SWIPE LEFT</div>
            </div>
          )}

        </div>
        <div id='lastPage' style={this.state.displayLastPage === true ? { display: "block", height: "100vh", opacity: 0.7, backgroundColor: "black", position: "relative", overflow: "hidden" } : { display: "none" }}>
          <div className="firework" style={{ position: "absolute", top: "60%", left: "50%" }}></div>
          <div className="firework" style={{ position: "absolute", top: "60%", left: "20%" }}></div>
          <div className="firework" style={{ position: "absolute", top: "60%", left: "80%" }}></div>
          <div style={{ color: "white", position: "relative", zIndex: 2, paddingTop: "10px" }}>
            <div style={{ backgroundImage: "url(/img/Logo.jpeg)", backgroundSize: "contain", backgroundRepeat: "no-repeat", height: "100px", width: "100px", filter: "brightness(0) invert(1)", marginLeft: "10px", marginBottom: "30px" }} />
            <div style={{ fontFamily: "'Caveat', cursive", fontSize: "28px", padding: "0 10px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", textAlign: "center", marginTop: "-140px", marginLeft: "40px" }}>Your presence and prayers</div>
            <div style={{ fontFamily: "'Caveat', cursive", fontSize: "28px", padding: "0 10px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", textAlign: "center", marginLeft: "40px" }}>will be a blessing to us</div>
            <div style={{ fontFamily: "'Caveat', cursive", fontSize: "28px", padding: "0 10px", color: "#ffffff", textShadow: "2px 2px 4px rgba(0,0,0,0.5)", fontWeight: "400", textAlign: "center", marginLeft: "40px" }}>on this special day!</div>
          </div>
        </div>
      </>
    );
  }
}

export default MainAppContainer;